<div class="feedback-container">
  <h1>Albion Free Market Feedback / Contact</h1>

  <mat-card>
    <mat-card-header>
      <mat-card-title>Get in Touch</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <p class="intro-text">
        We value your feedback! If you find any errors in our tools or have suggestions for improvement, please let our team know through one of the channels
        below.
      </p>

      <mat-divider></mat-divider>

      <h3>Contact Us</h3>

      <div class="contact-method">
        <mat-icon>email</mat-icon>
        <p>Email us at:&nbsp;<a href="mailto:albionfreemarket@gmail.com">albionfreemarket&#64;gmail.com</a></p>
      </div>

      <div class="social-buttons">
        <a mat-raised-button color="primary" class="social-button" href="https://discord.gg/BPmDE3zznH" target="_blank">
          <mat-icon>forum</mat-icon> Join our Discord
        </a>
        <a mat-raised-button color="accent" class="social-button" href="https://www.youtube.com/@AlbionFreeMarket" target="_blank">
          <mat-icon>smart_display</mat-icon> Subscribe on YouTube
        </a>
      </div>

      <mat-divider></mat-divider>

      <p class="intro-text" style="margin-top: 20px">
        <strong>Discord is our preferred contact method</strong> for quick responses and community interaction. Join our growing community to discuss market
        trends, get help with our tools, and connect with fellow Albion traders!
      </p>
    </mat-card-content>
  </mat-card>
</div>
